<script>
  import EarlyAccess from "$lib/Landing/EarlyAccess.svelte";
</script>

<svelte:head>
  <title>Early access — SmartClaim</title>
  <meta
    name="description"
    content="Request early access to SmartClaim, the AI platform helping UK R&D tax advisors draft technical narratives faster and more robustly."
  />
  <link rel="canonical" href="https://smartclaim.uk/early-access" />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://smartclaim.uk/early-access" />
  <meta property="og:title" content="Early access — SmartClaim" />
  <meta
    property="og:description"
    content="Request early access to SmartClaim, the AI platform helping UK R&D tax advisors draft technical narratives faster and more robustly."
  />
</svelte:head>

<EarlyAccess />
